module.exports = __webpack_public_path__ + "static/LandingImage-0b328a878b91de17b1ae00a4eed5c984.jpg";